export default __webpack_public_path__ + "static/media/searchIcon2.711820c2.svg";